import Input from "../../../components/input";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createNewPassword } from "../../../hooks/local/userReducer";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import { FiLock } from "react-icons/fi";

const ResetPassword = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.user.loading);

  const createNewPasswordForm = useFormik({
    initialValues: {
      new_password: "",
      confirm_new_password: "",
    },
   
    validationSchema: Yup.object({
  new_password: Yup.string()
    .required("Password cannot be empty")
    .min(12, "Password must be at least 12 characters long")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[0-9]/, "Password must contain at least one digit")
    .matches(
      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/,
      "Password must contain at least one special character"
    ),

  confirm_new_password: Yup.string()
    .oneOf([Yup.ref("new_password"), null], "Passwords must match")
    .required("Please confirm your password"),
}),

    onSubmit: async (values, { resetForm }) => {
      const { new_password } = values;
      let newPasswordFormData = {
        new_password,
        email,
        token,
      };
      const { payload } = await dispatch(
        createNewPassword({ newPasswordFormData, navigate })
      );
      if (payload.statuscode === "00") {
        resetForm();
        navigate("/");
      }
    },
  });

  return (
    <div className="w-full">
      <div className="mb-10 text-center md:text-left">
        <h2 className="text-2xl font-bold dark:text-white mb-2">Create new password</h2>
        <p className="text-gray-400 text-sm">Enter your new secure password below</p>
      </div>

      <form onSubmit={createNewPasswordForm.handleSubmit} className="grid gap-6">
        <Input
          label={"New password"}
          type={"password"}
          isPassword={"true"}
          name={"new_password"}
          placeholder="············"
          prefixIcon={FiLock}
          value={createNewPasswordForm.values.new_password}
          onBlur={createNewPasswordForm.handleBlur}
          onChange={createNewPasswordForm.handleChange}
          onError={
            createNewPasswordForm.touched.new_password &&
            createNewPasswordForm.errors.new_password
          }
        />
        <Input
          label={"Confirm password"}
          type={"password"}
          isPassword={"true"}
          name={"confirm_new_password"}
          placeholder="············"
          prefixIcon={FiLock}
          value={createNewPasswordForm.values.confirm_new_password}
          onBlur={createNewPasswordForm.handleBlur}
          onChange={createNewPasswordForm.handleChange}
          onError={
            createNewPasswordForm.touched.confirm_new_password &&
            createNewPasswordForm.errors.confirm_new_password
          }
        />

        <div className="mt-4">
          <Button
            buttonRole={"submit"}
            loading={loading}
            buttonText={"Reset password"}
            width="w-full"
            bgColor="bg-primaryBlue text-white w-full py-4 text-lg font-semibold rounded-lg shadow-lg shadow-blue-200 dark:shadow-none transition-transform active:scale-[0.98]"
          />
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
